/**
 * Décodage côté client du payload d'un JWT.
 *
 * Sécurité : on NE vérifie PAS la signature ici — c'est le rôle du backend
 * sur chaque requête API. On se contente de lire les claims publics
 * (`licence_valid`, `registered`, `method`…) pour piloter l'UI.
 */

export interface JwtPayload {
  pseudo?: string;
  licence_valid?: boolean;
  email_verified?: boolean;
  registered?: string;
  method?: string;
  exp?: number;
  iat?: number;
  [key: string]: unknown;
}

function base64UrlDecode(input: string): string {
  // Convertit base64url -> base64 standard, puis décode en UTF-8
  let s = input.replace(/-/g, '+').replace(/_/g, '/');
  const pad = s.length % 4;
  if (pad) s += '='.repeat(4 - pad);
  try {
    const raw = atob(s);
    try {
      return decodeURIComponent(
        raw
          .split('')
          .map((c) => '%' + c.charCodeAt(0).toString(16).padStart(2, '0'))
          .join('')
      );
    } catch {
      return raw;
    }
  } catch {
    return '';
  }
}

export function decodeJwtPayload(token: string | null | undefined): JwtPayload | null {
  if (!token || typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length < 2) return null;
  const json = base64UrlDecode(parts[1]);
  if (!json) return null;
  try {
    return JSON.parse(json) as JwtPayload;
  } catch {
    return null;
  }
}

/** Le JWT est-il (encore) valide ? `exp` est en secondes. */
export function isJwtExpired(payload: JwtPayload | null): boolean {
  if (!payload?.exp) return false;
  return payload.exp * 1000 < Date.now();
}
